import './App.css';
import Navbar from './components/Navbar';
import Flashcards from './components/Flashcards/Flashcards';
import CardTypes from './components/CardTypes/CardTypes';
import Home from './components/Home';
import Training from './components/Trainings/Training';
import Statistic from './components/Statistic/Statistic';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import Login from './components/Auth/Login';
import Register from './components/Auth/Register';
import Profile from './components/Auth/Profile';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Navbar />

        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/flashcards" component={Flashcards} />
          <Route path="/card-types" component={CardTypes} />
          <Route path="/training" component={Training} />
          <Route path="/statistic" component={Statistic} />
          <Route exact path="/login" component={Login} />
          <Route exact path="/register" component={Register} />
          <Route exact path="/profile" component={Profile} />
        </Switch>
      </div>
    </BrowserRouter>
  );
}

export default App;
